module.exports = "<form [formGroup]=\"selectStatusForm\">\r\n  <select formControlName=\"statusSelected\" required *ngIf=\"!onlyForCancel\">\r\n    <option [ngValue]=\"null\" disabled>Select status</option>\r\n    <option *ngFor=\"let status of arrayStatus\" [ngValue]=\"status.id\">{{ status.description }}</option>\r\n  </select>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/next-status-select/next-status-select.component.html
// module id = 2620
// module chunks = 66